<template>
    <SharedWidgetPage
        :title="title"
        :widget-page-id="widgetPageId"
        @widget-page-id-change="changeWidgetPageId"
    />
</template>

<script setup>
    import { useRoute } from 'vue-router'
    import SharedWidgetPage from '@/views/shared/SharedWidgetPage.vue'

    const route = useRoute()

    const title = ref(route.query.title ?? 'Widget')
    const widgetPageId = ref(route.params.widgetPageId)

    const changeWidgetPageId = (newWidgetPageId) => {
        widgetPageId.value = newWidgetPageId
    }

    watch(() => route.params.widgetPageId, (newId) => {
        widgetPageId.value = newId
    })
</script>
